import { useMemo } from "react";
import { useGetGamificationByIdQuery } from "../../../../../services/gamification";
import {
  type IGamification,
  type IGamificationCampaignDto,
  type IProbability,
} from "../../../../../@types/gamification";
import { mapStatusToFrontend } from "../../utils/status-mapper";

function probabilitiesOf(item: IGamificationCampaignDto): IProbability[] {
  return Array.isArray(item.discountProbabilities)
    ? item.discountProbabilities
    : item.discountProbabilities.intervals;
}

function mapCampaign(item: IGamificationCampaignDto): IGamification {
  return {
    id: item.id,
    idCapa: item.idCapa,
    nickname: item.campaignName,
    slug: item.slug ?? undefined,
    startDate: item.startDate,
    endDate: item.endDate,
    status: mapStatusToFrontend(item.status, item.deletedAt ?? null),
    campaignType: item.mechanic,
    mechanic: item.mechanic,
    mechanicConfig: item.mechanicConfig,
    faqItems: item.faqItems ?? [],
    stores: item.stores.map((store) => ({
      storeCode: String(store.code),
      storeName: store.name,
      nickname: store.nickname,
    })),
    allStoresSelected: item.allStoresSelected,
    hasRegulationFile: item.hasRegulationFile,
    hasBanner3x4: item.hasBanner3x4,
    hasBanner16x9: item.hasBanner16x9,
    banner3x4Url: item.banner3x4Url,
    banner16x9Url: item.banner16x9Url,
    probabilities: probabilitiesOf(item),
    regulations: item.regulations,
    createdAt: item.createdAt,
    updatedAt: item.updatedAt,
    deletedAt: item.deletedAt ?? undefined,
  };
}

export const useCampaignData = (campaignId: number) => {
  const { data: rawData, isLoading, error } =
    useGetGamificationByIdQuery(campaignId);

  const campaign = useMemo(
    () => (rawData ? mapCampaign(rawData.data) : undefined),
    [rawData],
  );

  return { campaign, isLoading, error };
};
